var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgImgFileAudio = function SvgImgFileAudio(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFEF",
    fillRule: "nonzero",
    d: "M0 0h120v120H0z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#BDBDBD",
    strokeWidth: 1.2,
    transform: "translate(36.923 24.615)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M12.308 68.292c-.802 0-1.452.65-1.452 1.452v1.05c0 .222.18.4.4.4h23.641a.4.4 0 0 0 .4-.4v-1.05c0-.802-.65-1.452-1.45-1.452h-21.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M20.513 50.256v3.59a2.564 2.564 0 1 0 5.128 0v-3.59"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M23.077 56.41v11.795"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.441,
    height: 41.877,
    x: 10.856,
    y: 0.6,
    fill: "#B5D100",
    fillOpacity: 0.3,
    rx: 12.221
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M11.282 13.846h5.128m13.334 0h5.128m-23.59 5.641h5.078m13.384 0h5.077"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.103 22.564v8.718c0 10.48 8.495 18.974 18.974 18.974 10.48 0 18.974-8.495 18.974-18.974v-8.718m-41.025 3.59h44.102M.513 24.103v4.102m44.615-4.102v4.102M23.077 35.59v6.461m-4.615-6.461v5.948m9.23-5.948v5.948"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImgFileAudio);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/img-file-audio.47d0907f50f1aade335f56b15ba249e7.svg";